//ES6 SCROM API WRAPPER

// set this to false to turn debugging off
// and get rid of those annoying alert boxes.
const _Debug = false;  // set this to false to turn debugging off

// Define exception/error codes

const _NoError = 0;
const _GeneralException = 101;
const _ServerBusy = 102;
const _InvalidArgumentError = 201;
const _ElementCannotHaveChildren = 202;
const _ElementIsNotAnArray = 203;
const _NotInitialized = 301;
const _NotImplementedError = 401;
const _InvalidSetValue = 402;
const _ElementIsReadOnly = 403;
const _ElementIsWriteOnly = 404;
const _IncorrectDataType = 405;

// local variable definitions
let apiHandle = null;
let API = null;
let findAPITries = 0;


let resolveObj = {
    success: true,
    message: "",
    data: ""
};

let rejectObj= {
    success: false,
    message: "",
    data: ""
};
/*******************************************************************************
 ** Inputs:  None
 ** Return:  CMIBoolean true if the initialization was successful, or
 **          CMIBoolean false if the initialization failed.
 **
 ** Description:
 ** Initialize communication with LMS by calling the LMSInitialize
 ** function which will be implemented by the LMS.
 **
 *******************************************************************************/

export function doLMSInitialize() {
    return new Promise(function (resolve, reject) {
       // conso le.log("doLMSInitialize");
        let api = getAPIHandle();
       // console.log('api',api);
        if (api == null) {
            //alert("Unable to locate the LMS's API Implementation.\nLMSInitialize was not successful.");
            //reject(ErrorHandler());
            reject(Object.assign({},rejectObj,{
                message: `Error: doLMSInitialize(): ${ErrorHandler()}`,
                result : ErrorHandler()
            }));
        }

        let result = api.LMSInitialize("");

        if (result.toString() != "true") {
            reject(Object.assign({},rejectObj,{
                message: `Error: doLMSInitialize(): ${ErrorHandler()}`,
                data: ErrorHandler()
            }));
        }
        //alert('doLMSInitialize() - ' + result);
        resolve(Object.assign({},resolveObj,{
            message: `Success: doLMSInitialize(): ${result.toString()}`,
            data: result.toString()
        }));
    });
}

/*******************************************************************************
 **
 ** Function doLMSFinish()
 ** Inputs:  None
 ** Return:  CMIBoolean true if successful
 **          CMIBoolean false if failed.
 **
 ** Description:
 ** Close communication with LMS by calling the LMSFinish
 ** function which will be implemented by the LMS
 **
 *******************************************************************************/

export function doLMSFinish() {
    return new Promise(function (resolve, reject) {
        //console.log("doLMSFinish");
        let api = getAPIHandle();
        let result = "";

        if (api == null) {
            //alert("Unable to locate the LMS's API Implementation.\nLMSFinish was not successful.");
            reject(Object.assign({},rejectObj,{
                message: `Error: doLMSFinish(): ${ErrorHandler()}`,
                data: ErrorHandler()
            }));
        }
        else {
            // call the LMSFinish function that should be implemented by the API

            let result = api.LMSFinish("");
            if (result.toString() != "true") {
                let err = ErrorHandler();
                reject(Object.assign({},rejectObj,{
                    message: `Error: doLMSFinish(): ${ErrorHandler()}`,
                    data: ErrorHandler()
                }));
            }

        }
        //alert('doLMSFinish() - ' + result);
        resolve(Object.assign({},resolveObj,{
            message: `Success: doLMSFinish(): ${result.toString()}`,
            data: result.toString()
        }));
    });
}

/*******************************************************************************
 **
 ** Function doLMSGetValue(name)
 ** Inputs:  name - string representing the cmi data model defined category or
 **             element (e.g. cmi.core.student_id)
 ** Return:  The value presently assigned by the LMS to the cmi data model
 **       element defined by the element or category identified by the name
 **       input value.
 **
 ** Description:
 ** Wraps the call to the LMS LMSGetValue method
 **
 *******************************************************************************/

export function doLMSGetValue(name) {
    return new Promise(function (resolve, reject) {
        let api = getAPIHandle();
        if (api == null) {
            //alert("Unable to locate the LMS's API Implementation.\nLMSGetValue was not successful.");
            reject(Object.assign({},rejectObj,{
                message: `Error: doLMSGetValue(${name}): ${ErrorHandler()}`,
                data: ErrorHandler()
            }));
        }
        else {
            let value = api.LMSGetValue(name);
            let errCode = api.LMSGetLastError().toString();
            if (errCode != _NoError) {
                // an error was encountered so display the error description
                let errDescription = api.LMSGetErrorString(errCode);
                //alert("LMSGetValue("+name+") failed. \n"+ errDescription);
                reject(Object.assign({},rejectObj,{
                    message: `Error: doLMSGetValue(${name}): \n ${errDescription}`,
                    data: errDescription
                }));

            }
            else {
                //alert('doLMSGetValue() - ' + value);

                resolve(Object.assign({},resolveObj,{
                    message: `Success: doLMSGetValue(${name}): ${value.toString()}`,
                    data: value.toString()
                }));
            }
        }
    });
}

/*******************************************************************************
 **
 ** Function doLMSSetValue(name, value)
 ** Inputs:  name -string representing the data model defined category or element
 **          value -the value that the named element or category will be assigned
 ** Return:  CMIBoolean true if successful
 **          CMIBoolean false if failed.
 **
 ** Description:
 ** Wraps the call to the LMS LMSSetValue function
 **
 *******************************************************************************/

export function doLMSSetValue(name, value) {
    return new Promise(function (resolve, reject) {
        let api = getAPIHandle();
        let result = "";
        if (api == null) {
            //alert("Unable to locate the LMS's API Implementation.\nLMSSetValue was not successful.");
            reject(Object.assign({},rejectObj,{
                message: `Error: doLMSSetValue(${name},${value}): ${ErrorHandler()}`,
                data: ErrorHandler()
            }));
        }
        else {
            let result = api.LMSSetValue(name, value);
            if (result.toString() != "true") {
                let err = ErrorHandler();
                reject(Object.assign({},rejectObj,{
                    message: `Error: doLMSSetValue(${name},${value}): ${ErrorHandler()}`,
                    data: ErrorHandler()
                }));
            }
        }
        //alert('doLMSSetValue(name) - ' + name + ' , doLMSSetValue(value) - ' + value);
        //resolve(`success: doLMSSetValue(name) - ${name} , doLMSSetValue(value) - ${value}`);
        resolve(Object.assign({},resolveObj,{
            message: `Success: doLMSSetValue(${name},${value}): ${result.toString()}`,
            data: result.toString()
        }));
    });
}

/*******************************************************************************
 **
 ** Function doLMSCommit()
 ** Inputs:  None
 ** Return:  None
 **
 ** Description:
 ** Call the LMSCommit function
 **
 *******************************************************************************/

export function doLMSCommit() {
    return new Promise(function (resolve, reject) {
        //console.log(`doLMSCommit`);
        let api = getAPIHandle();
        let result = "";
        if (api == null) {
            //alert("Unable to locate the LMS's API Implementation.\nLMSCommit was not successful.");
            reject(Object.assign({},rejectObj,{
                message: `Error: doLMSCommit(): ${ErrorHandler()}`,
                data: ErrorHandler()
            }));
        }
        else {
            result = api.LMSCommit("");
            if (result != "true") {
                let err = ErrorHandler();
                reject(Object.assign({},rejectObj,{
                    message: `Error: doLMSCommit(): ${ErrorHandler()}`,
                    data: ErrorHandler()
                }));
            }
        }
        //alert('doLMSCommit() - ' + result);
        //resolve(result.toString());
        //console.log(result.toString());
        resolve(Object.assign({},resolveObj,{
            message: `Success: doLMSCommit(): ${result.toString()}`,
            data: result.toString()
        }));
    });
}

/*******************************************************************************
 **
 ** Function doLMSGetLastError()
 ** Inputs:  None
 ** Return:  The error code that was set by the last LMS function call
 **
 ** Description:
 ** Call the LMSGetLastError function
 **
 *******************************************************************************/

export function doLMSGetLastError() {
    return new Promise(function (resolve, reject) {
        let api = getAPIHandle();
        if (api == null) {
            //alert("Unable to locate the LMS's API Implementation.\nLMSGetLastError was not successful.");
            //since we can't get the error code from the LMS, return a general error
            reject(Object.assign({},rejectObj,{
                message: `Error: doLMSGetLastError(): ${ErrorHandler()}`,
                data: ErrorHandler()
            }));
        }

        //resolve(api.LMSGetLastError().toString());
        resolve(Object.assign({},resolveObj,{
            message: `Success: doLMSGetLastError(): ${api.LMSGetLastError().toString()}`,
            data: api.LMSGetLastError().toString()
        }));
    });
}

/*******************************************************************************
 **
 ** Function doLMSGetErrorString(errorCode)
 ** Inputs:  errorCode - Error Code
 ** Return:  The textual description that corresponds to the input error code
 **
 ** Description:
 ** Call the LMSGetErrorString function
 **
 ********************************************************************************/

export function doLMSGetErrorString(errorCode) {
    return new Promise(function (resolve, reject) {
        let api = getAPIHandle();
        if (api == null) {
            //alert("Unable to locate the LMS's API Implementation.\nLMSGetErrorString was not successful.");
            reject(Object.assign({},rejectObj,{
                message: `Error: doLMSGetErrorString(${errorCode}): ${ErrorHandler()}`,
                data: ErrorHandler()
            }));
        }

        //resolve(api.LMSGetErrorString(errorCode).toString());
        resolve(Object.assign({},resolveObj,{
            message: `Success: doLMSGetErrorString(${errorCode}): ${api.LMSGetErrorString(errorCode).toString()}`,
            data: api.LMSGetErrorString(errorCode).toString()
        }));
    });
}

/*******************************************************************************
 **
 ** Function doLMSGetDiagnostic(errorCode)
 ** Inputs:  errorCode - Error Code(integer format), or null
 ** Return:  The vendor specific textual description that corresponds to the
 **          input error code
 **
 ** Description:
 ** Call the LMSGetDiagnostic function
 **
 *******************************************************************************/

function doLMSGetDiagnostic(errorCode) {
    return new Promise(function (resolve, reject) {
        let api = getAPIHandle();
        if (api == null) {
            //alert("Unable to locate the LMS's API Implementation.\nLMSGetDiagnostic was not successful.");
            reject(Object.assign({},rejectObj,{
                message: `Error: doLMSGetDiagnostic(${errorCode}): ${ErrorHandler()}`,
                data: ErrorHandler()
            }));
        }

        //resolve(api.LMSGetDiagnostic(errorCode).toString());
        resolve(Object.assign({},resolveObj,{

            message: `Success: doLMSGetDiagnostic(${errorCode}): ${api.LMSGetDiagnostic(errorCode).toString()}`,
            data: api.LMSGetErrorString(errorCode).toString()
        }));
    });
}

/*******************************************************************************
 **
 ** Function LMSIsInitialized()
 ** Inputs:  none
 ** Return:  true if the LMS API is currently initialized, otherwise false
 **
 ** Description:
 ** Determines if the LMS API is currently initialized or not.
 **
 *******************************************************************************/

export function LMSIsInitialized() {
    // there is no direct method for determining if the LMS API is initialized
    // for example an LMSIsInitialized function defined on the API so we'll try
    // a simple LMSGetValue and trap for the LMS Not Initialized Error
    return new Promise(function (resolve, reject) {
        let api = getAPIHandle();
        if (api == null) {
            //alert("Unable to locate the LMS's API Implementation.\nLMSIsInitialized() failed.");
            reject(Object.assign({},rejectObj,{
                message: `Error: LMSIsInitialized(): ${ErrorHandler()}`,
                data: ErrorHandler()
            }));
        }
        else {
            let value = api.LMSGetValue("cmi.core.student_name");
            let errCode = api.LMSGetLastError().toString();
            if (errCode == _NotInitialized) {
                resolve(Object.assign({},resolveObj,{
                    message: `Success: LMSIsInitialized(): false`,
                    data: `false`
                }));
            }
            else {
                resolve(Object.assign({},resolveObj,{
                    message: `Success: LMSIsInitialized(): true`,
                    data: `true`
                }));
            }
        }
    });
}

/*******************************************************************************
 **
 ** Function ErrorHandler()
 ** Inputs:  None
 ** Return:  The current value of the LMS Error Code
 **
 ** Description:
 ** Determines if an error was encountered by the previous API call
 ** and if so, displays a message to the user.  If the error code
 ** has associated text it is also displayed.
 **
 *******************************************************************************/

export function ErrorHandler() {

    let api = getAPIHandle();
    if (api == null) {
        return `Unable to locate the LMS's API Implementation.\nCannot determine LMS error code.`;
    }

    // check for errors caused by or from the LMS
    let errCode = api.LMSGetLastError().toString();
    if (errCode != _NoError) {
        // an error was encountered so display the error description
        let errDescription = api.LMSGetErrorString(errCode);

        if (_Debug == true) {
            errDescription += "\n";
            errDescription += api.LMSGetDiagnostic(null);
            // by passing null to LMSGetDiagnostic, we get any available diagnostics
            // on the previous error.
        }

        //alert(errDescription);
    }
    return errCode;
}

/******************************************************************************
 **
 ** Function getAPIHandle()
 ** Inputs:  None
 ** Return:  value contained by APIHandle
 **
 ** Description:
 ** Returns the handle to API object if it was previously set,
 ** otherwise it returns null
 **
 *******************************************************************************/

export function getAPIHandle() {
    if (apiHandle == null) {
        apiHandle = getAPI();
    }

    return apiHandle;
}

/*******************************************************************************
 **
 ** Function findAPI(win)
 ** Inputs:  win - a Window Object
 ** Return:  If an API object is found, it's returned, otherwise null is returned
 **
 ** Description:
 ** This function looks for an object named API in parent and opener windows
 **
 *******************************************************************************/

export function findAPI(win) {
    while ((win.API == null) && (win.parent != null) && (win.parent != win)) {
        findAPITries++;
        // Note: 7 is an arbitrary number, but should be more than sufficient
        if (findAPITries > 7) {
            //alert("Error finding API -- too deeply nested.");
            return null;
        }

        win = win.parent;

    }
    return win.API;
}

/*******************************************************************************
 **
 ** Function getAPI()
 ** Inputs:  none
 ** Return:  If an API object is found, it's returned, otherwise null is returned
 **
 ** Description:
 ** This function looks for an object named API, first in the current window's
 ** frame hierarchy and then, if necessary, in the current window's opener window
 ** hierarchy (if there is an opener window).
 **
 *******************************************************************************/

export function getAPI() {
    let theAPI = findAPI(window);
    if ((theAPI == null) && (window.opener != null) && (typeof(window.opener) != "undefined")) {
        theAPI = findAPI(window.opener);
    }
    if (theAPI == null) {
        // alert("Unable to find an API adapter");
    }
    return theAPI;
}








/** WEBPACK FOOTER **
 ** ./src/wrappers/scorm/APIWrap.js
 **/